{
  "top-salons-page": {
    "text": {
      "title": "Salon hàng đầu",
      "hint": "Khám phá những salon làm đẹp phổ biến nhất tại các thành phố yêu thích của bạn.",
      "country-label": "Quốc gia",
      "country": {
        "DE": "Đức",
        "CH": "Thụy Sĩ",
        "NL": "Hà Lan"
      }
    },
    "meta": {
      "title": "Salon hàng đầu | Beauty Booking",
      "description": "Khám phá những salon làm đẹp phổ biến nhất tại Đức, Thụy Sĩ và Hà Lan."
    }
  }
}
